let firmware = {
    version: "Version",
    enterVersion: "Version code cannot be empty",
    versionCode: "Please enter a positive integer between 1 and 999999",
    srcVersion: "Source Version",
    enterSrcVersion: "Please enter source version",
    targetVersion: "Target Version",
    selTargetVersion: "Please select target version",
    versionName: "Name",
    enterVersionName: "Version name cannot be empty",
    addFirmware: "Add Firmware",
    updateFirmware: "Edit Firmware",
    firmwareDetail: "Firmware Detail",
    packageUrl: "Package URL",
    packageType: "Package Type",
    fullPackage: "Full Package",
    diffPackage: "Differential Package",
    diffPackageNote: "Differential packages from low version (source version number) to high version (version number)",

    addOtaTask: "Add OTA Task",
    upgradeDetail: "Task Detail",
    releaseUpgrade: "Release Upgrade",
    cancelUpgrade: "Cancle Upgrade",
    upgradeId: "Upgrade Id",
    upgradeName: "Upgrade Name",
    enterUpgradeName: "Upgrade name required",
    upgradeScope: "Upgrade Scope",
    selUpgradeScope: "Upgrade scope cannot be empty",
    selUpgradeType: "Upgrade type cannot be empty",
    allDevice: "All device",
    checkedDevice: "Selected Devices",
    orgDevice: "Device under the organization",
    unreleased: "Unreleased",
    released: "Released",
    executeTime: "Execute Time",
    executeNow: "Execute Now",
    executeSelTime: "Execute specify time",
    confirmCancelRelease: "Confirm cancel release {name} ?",
    targetDevice: "Target Devices",
    confirmDeleteDevice: "Delete device {name}?"

}

export default firmware
